<script>
import { mapActions } from 'vuex'
import OperationForm from '@/components/fiche-aim/fiche-aim/ajustement/operation/operation-form.vue'

export default {
  components: { OperationForm },
  emits: ['created', 'close'],
  props: {
    ficheAimId: {
      type: Number,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formValid: false,
      montant: undefined,
      justification: undefined,
      remboursements: [],
    }
  },
  computed: {
    isValid() {
      return (
        this.montant !== undefined &&
        !Number.isNaN(this.montant) &&
        Number(this.montant) > 0 &&
        this.justification !== undefined
      )
    },
    totalRemboursements() {
      return this.remboursements
        .map((r) => r.montantRemboursement)
        .reduce((previousValue, currentValue) => Number(previousValue) + Number(currentValue), 0)
    },
    operationsRemboursements() {
      let operations = []
      this.remboursements.forEach((r) => {
        operations.push({
          montant: Number(r.montantRemboursement),
          posteAIMId: 'DETTE',
        })
        operations.push({
          montant: Number(r.montantRemboursement) * -1,
          posteAIMId: r.posteRemboursement.posteAIMId,
        })
      })
      return operations
    },
  },
  methods: {
    ...mapActions({
      ajuster: 'ficheAIM/ajusterFicheAIM',
    }),
    clear() {
      this.remboursements = []
    },
    submitAjustement() {
      this.ajuster({
        ficheAIMId: this.ficheAimId,
        explication: this.justification,
        operations: [
          {
            montant: -1 * Number(this.montant),
            posteAIMId: 'DETTE',
          },
          ...this.operationsRemboursements,
        ],
      }).then((ajustement) => {
        this.clear()
        this.$emit('created', ajustement)
      })
    },
    ajouterRemboursement(remboursement) {
      this.remboursements.push(remboursement)
    },

    removeRemboursement(remboursement) {
      this.remboursements.splice(this.remboursements.indexOf(remboursement), 1)
    },
  },
}
</script>

<template>
  <v-bottom-sheet :value="active" inset origin="left bottom" persistent @close="$emit('closes')">
    <v-form v-model="formValid" @submit.prevent="submitAjustement">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-icon color="secondary" size="32" class="pr-2">mdi-hand-coin</v-icon>
            Déclaration de dette
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="montant"
                dense
                suffix="€"
                clearable
                outlined
                type="number"
                label="Montant"
                hide-spin-buttons
                :rules="[
                  (v) => !!v || 'Vous devez renseigner un montant positif',
                  (v) => Number(v) > 0 || 'Le montant doit être positif',
                ]"
              />
            </v-col>
            <v-col cols="9">
              <v-textarea
                class="textarea"
                outlined
                label="Justification"
                no-resize
                rows="2"
                required
                v-model="justification"
                :rules="[(v) => !!v || 'Vous devez renseigner une justification']"
              />
            </v-col>
          </v-row>
          <v-row no-gutters align="center">
            <v-col cols="5">
              <operation-form
                titre="Rembourser"
                soustitre="Le remboursement peut aussi se faire a posteriori"
                @input="ajouterRemboursement"
              />
            </v-col>
            <v-col class="px-6" cols="auto" align-self="center">
              <v-icon :color="'primary'" x-large> mdi-arrow-right-circle</v-icon>
            </v-col>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <v-row no-gutters justify="space-between">
                    Remboursements
                    <v-chip :color="totalRemboursements - montant === 0 ? 'success' : ''">
                      {{ totalRemboursements }} / {{ montant !== undefined ? montant : 0 }} €
                    </v-chip>
                  </v-row>
                </v-card-title>
                <v-card-subtitle>La dette peut être remboursé plus tard</v-card-subtitle>
                <v-card-text>
                  <v-chip-group column>
                    <v-chip v-for="(r, i) in remboursements" :key="i" close @click:close="removeRemboursement(r)"
                      >{{ r.posteRemboursement.libelle }} :
                      <strong class="pl-1">{{ r.montantRemboursement }}€</strong></v-chip
                    >
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn type="submit" @click="clear">Vider</v-btn>
          <v-btn @click="$emit('close')">fermer</v-btn>
          <v-btn type="submit" :disabled="!isValid" color="success">
            <v-fab-transition>
              <v-icon v-if="isValid">mdi-plus</v-icon>
            </v-fab-transition>
            Créer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-bottom-sheet>
</template>
